import { useState, useEffect } from "react";
import {
    StyleSheet, View, Text
} from "react-native";

import { FONT } from "../../../value/staticValues";
import { PLATFORM_URL } from "../../../value/Url";
import { requests } from "../../../common/RestAPI";

import { CustomTextInput } from "../../base/CustomInputText";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";

import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';

import { useTranslation } from "react-i18next";
import CustomText from "components/base/CustomText";

interface FloatingIpAddProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    showSlideModalCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
};

FloatingIpAdd.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function FloatingIpAdd(props:FloatingIpAddProps) {
    const { t } = useTranslation();

    const [stepIndex, setStepIndex] = useState(0);
    const [executeAddYn, setExecuteAddYn] = useState(false);
    
    const [floatingIpAddress, setFloatingIpAddress] = useState("");
    
    const [projectId, setProjectId] = useState("");
    const [networkId, setNetworkId] = useState("");
    const [subnetId, setSubnetId] = useState("");
    const [subnetList, setSubnetList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [networkList, setNetworkList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [projectList, setProjectList] = useState<DropdownType[]>([ { value: "", label: t("EMPTY_TEXT")} ]);
    const [projectChangeYn, setProjectChangeYn] = useState(false);
    const [networkChangeYn, setNetworkChangeYn] = useState(false);

    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);


    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            if(stepIndex < props.stepCount - 1) {
                if(stepIndex === 0) {
                    
                }
            } else {
                const successYn = checkFloatingIpData();
                if(successYn) {
                    setExecuteAddYn(true);
                }
            }
            
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(stepIndex === 0) {
            loadProjectList();
        }
    }, [stepIndex])

    useEffect(() => {
        if(projectChangeYn) {
            setProjectChangeYn(false);
        }
    }, [projectChangeYn])

    
    useEffect(() => {
        if(networkChangeYn) {
            setNetworkChangeYn(false);
        }
    }, [networkChangeYn])

    useEffect(() => {
        if(networkId && projectId) {
            setNetworkChangeYn(true);
            setSubnetId("");
            loadSubnetList();
        }
    }, [networkId]);

    useEffect(() => {
        if(projectId) {
            setProjectChangeYn(true);
            setSubnetId("");
            setNetworkId("");
            loadNetworkList();
        }
    }, [projectId]);

    useEffect(() => {
        if(executeAddYn) {
            executeAddFloatingIp();
        }
    }, [executeAddYn]);

    function checkFloatingIpData() {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        
        
        let message = "";
        let error = false;
        if(!networkId || !projectId) {
            message = t("MESSAGE_FLOATING_IP_INFO_ENTER_ERROR_MESSAGE")
            error = true;
        }
        if(error === true) {
            executeResult({}, false, message);
        }
        
        return !error;
    }
    function executeResult(result, closeYn, infoMessage) {
        setExecuteAddYn(false);
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }
    function loadSubnetList() {
        requests.get(PLATFORM_URL.VM_NETWORK + '/' + networkId + PLATFORM_URL.SUBNET)
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setSubnetList(response.data.items.map((data)=>{
                    return {value:data.subnet_id, label:data.subnet_name + "(" + data.cidr + ")"}
                }).filter(v => v !== false));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }
    function loadNetworkList() {
        requests.get(PLATFORM_URL.VM_NETWORK)
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setNetworkList(response.data.items.map((data)=>{
                    if(data.external_yn === false || data.network_status_code !== "ACT") {
                        return false;
                    }
                    if(data.share_type_code === "PRJ" && data.project.project_id !== projectId) {
                        return false;
                    }

                    return {value:data.network_id, label:data.network_name}
                }).filter(v => v !== false ));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }
    function loadProjectList() {
        requests.get(PLATFORM_URL.PROJECT)
        .then((response) => {
            if (response.status === 200 && response.data?.items) {
                setProjectList(response.data.items.map((data, index) => {
                    return { value: data.project_id, label: data.project_name };
                }));
            }
        })
        .catch((error) => {
            if(props.showMessageCb){
                props.showMessageCb(t("MESSAGE_CANNOT_LOAD_DATA_MESSAGE"));
            }
        });
    }

    function executeAddFloatingIp() {
        const addPackageData = {};
        if(floatingIpAddress) {
            addPackageData['floating_ip'] = {};
            addPackageData['floating_ip']['floating_ip_address'] = floatingIpAddress;
        }
        addPackageData['project'] = {};
        addPackageData['project']['project_id'] = projectId;
        addPackageData['network'] = {};
        addPackageData['network']['network_id'] = networkId;
        if(subnetId) {
            addPackageData['subnet'] = {};
            addPackageData['subnet']['subnet_id'] = subnetId;
        }
        requests.post(PLATFORM_URL.FLOATING_IP, addPackageData)
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else if(response.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_FLOATING_IP_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
            
        })
        .catch((error) => {
            if(error.status === 409) {
                executeResult({successYn: false}, false, t("MESSAGE_FLOATING_IP_ADD_DUPLICATED_ERROR_MESSAGE"));
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }
        });
    }


    return (
        <View>
            {
                stepIndex === 0 ?
                // 이름, 설명, 사용 유형, 사용 대상
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("FLOATING_IP_ADD_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <CustomText text={t("FLOATING_IP_ADDRESS_TEXT")} fontStyle={style.columnText} asterisk={false}/>
                            <CustomTextInput 
                                key={2} 
                                width={570} height={36} 
                                value={floatingIpAddress} 
                                type={"text"} 
                                activeYn={true} 
                                inputCb={setFloatingIpAddress} 
                                warnYn={false} 
                                placeHolderText={t("IP_ADDRESS_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowDivContainer}/>
                        <View style={style.rowContainer}>
                            <CustomText text={t("PROJECT_INFO_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown 
                                key={10} 
                                width={300} height={36} 
                                items={projectList}
                                setValue={setProjectId} 
                                disable={false}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View>
                        {
                            projectChangeYn === false ?
                        <View style={style.rowContainer}>
                            <CustomText text={t("NETWORK_INFO_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown 
                                key={130} 
                                width={300} height={36} 
                                items={networkList}
                                setValue={setNetworkId} 
                                disable={projectId ? false : true}
                                defaultvalue={{label:"", value:""}}
                            />
                        </View> : null
                        }
                        {
                            networkChangeYn === false ?
                        <View style={style.rowContainer}>
                            <CustomText text={t("SUBNET_INFO_TEXT")} fontStyle={style.columnText} asterisk={true}/>
                            <CustomDropDown 
                                key={140} 
                                width={300} height={36} 
                                items={subnetList}
                                setValue={setSubnetId} 
                                disable={projectId && networkId? false : true}
                                defaultvalue={{label:t("NETWORK_DEFAULT_SUBNET_TEXT"), value:""}}
                            />
                        </View> : null
                        }
                    </View>
                </View> 
                : null
            }
        </View>
    );
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",

    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 58,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
});


const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}